module.exports = __webpack_public_path__ + "static/untitled-sans-web-medium-5de923e4049a47334b9873d43d9c8a97.woff2";